import React from "react";
import { Route, Routes, useMatch } from "react-router-dom";
import LibraryRouter from "./library/LibraryRouter";
import MainRouter from "./main/MainRouter";
import ProfileRouter from "./profile/ProfileRouter";
import TrySharing from "./other/TrySharing";
import { useGetState } from "../components/ReduxProvider";
import Verify from "./other/Verify";
import Author from "./author/Author";
import AdminRouter from "./admin/AdminRouter";
import Share from "root/main/share/Share";
import { SOURCE } from "root/library/library/libraryUrls";
import {
  ADMIN,
  AUTHOR,
  LIBRARY,
  MAIN,
  PROFILE,
  SHARE,
  TRYSHARING,
  VERIFY,
  ONBOARDING,
  LATE_REGISTRATION,
  PRACTICE
} from "./RootRouter.config";
import OnboardingSteps from "./tutorial/onboarding/OnboardingSteps";
import { PASSWORD, HELP_CENTER, FEEDBACK } from "./profile/ProfileRouter.config";
import { LateRegistrationPage } from "./auth/LateRegistrationPage";
import HelpCenter from "./profile/HelpCenter/HelpCenter";
import Feedback from "./profile/feedback/Feedback";
import Practice from "./practice/Practice";
export const useLibraryUrl = () => {
  const libTopic = useGetState("libTopic");
  return LIBRARY.url(libTopic);
};

export const useMatchMain: (params?: { end: boolean }) => boolean = (p) => {
  const inMain = useMatch({ path: MAIN.url(), end: !!p?.end });
  const inMain2 = useMatch("/");
  return !!(inMain || inMain2);
};

export const useIsPublicUrl = () => {
  const pwdUrl = useMatch(PASSWORD.url());
  const trySharingUrl = useMatch(TRYSHARING.query());
  const libIndexUrl = useMatch(LIBRARY.root());
  const libUrl = useMatch(LIBRARY.query());
  const sourceUrl = useMatch(SOURCE.query());
  const authorUrl = useMatch(AUTHOR.query());
  const shareUrl = useMatch(SHARE.query());
  const feedbackUrl = useMatch(FEEDBACK.url());
  const verifyUrl = useMatch(VERIFY.url());
  return !!(
    pwdUrl ||
    trySharingUrl ||
    libIndexUrl ||
    libUrl ||
    sourceUrl ||
    authorUrl ||
    shareUrl ||
    feedbackUrl ||
    verifyUrl
  );
};

const RootRouter: React.FC<{}> = React.memo(() => {
  return (
    <Routes>
      <Route path={LIBRARY.root() + "/*"} element={<LibraryRouter />} />
      <Route path={PROFILE.url() + "/*"} element={<ProfileRouter />} />
      <Route path={TRYSHARING.query()} element={<TrySharing />} />
      <Route path={VERIFY.url()} element={<Verify />} />
      <Route path={AUTHOR.query()} element={<Author />} />
      <Route path={ADMIN.query() + "/*"} element={<AdminRouter />} />
      <Route path={SHARE.query()} element={<Share />} />
      <Route path={LATE_REGISTRATION.url()} element={<LateRegistrationPage />} />
      <Route path={MAIN.url() + "/*"} element={<MainRouter />} />
      <Route path={ONBOARDING.url() + "/*"} element={<OnboardingSteps />} />
      <Route path={HELP_CENTER.url()} element={<HelpCenter />} />
      <Route path={FEEDBACK.url()} element={<Feedback />} />
      <Route path={PRACTICE.url()} element={<Practice />} />
      <Route path="/*" element={<MainRouter />} />
    </Routes>
  );
});

export default RootRouter;
